<div class="container-sm">
    <h1 class="m-3 display-6 vm-container-header"><i class="bi bi-flag me-2"></i> Feature Flags</h1>

    <div class="pb-5">
        <div class="bg-body-light rounded-3 shadow">
            <div class="m-2 pb-1">
                <form autocomplete="off">
                    <div class="mb-3 mx-0 row align-items-center">
                        <app-table-search [(value)]="this.service.searchTerm" />

                        <div class="col-sm-auto ms-auto">
                            <button type="button" class="btn btn-outline-primary" (click)="onHistory(null)">
                                <i class="bi bi-clock-history me-1"></i> Recent changes to all flags
                            </button>
                        </div>
                    </div>
                </form>

                @if ((this.total$ | async) ?? 0) {
                    <table class="table table-striped table-hover">
                        <caption>{{ this.total$ | async }} Total</caption>

                        <thead>
                        <tr>
                            <th scope="col" sortable="code" (sort)="this.onSort($event)">Code</th>
                            <th scope="col" sortable="description" (sort)="this.onSort($event)">Description</th>
                            <th scope="col" class="text-center" sortable="isActive" (sort)="this.onSort($event)">
                                Is Enabled
                            </th>
                            <th scope="col" class="text-center">Users</th>
                            <th scope="col" class="text-center">Actions</th>
                        </tr>
                        </thead>

                        <tbody class="table-group-divider">
                            @for (element of this.featureFlags$ | async; track element.code; ) {
                                <tr>
                                    <td class="align-middle">{{ element.code }}</td>
                                    <td class="align-middle" title="{{ element.description }}"
                                        style="max-width: 20em;">
                                        {{ element.description }}
                                    </td>
                                    <td class="align-middle text-center">
                                        @if (element.isEnabled) {
                                            <span class="badge text-bg-success"><i class="bi bi-check-lg"></i></span>
                                        }
                                    </td>
                                    <td class="align-middle text-center">
                                        {{ element.users.length || 0 }}
                                    </td>
                                    <td class="align-middle text-center">
                                        <div class="btn-group">
                                            <button type="button" class="btn btn-sm btn-outline-primary bi bi-pencil"
                                                    title="Edit environment feature flags"
                                                    [attr.aria-label]="'Edit ' + element.code"
                                                    (click)="onEdit(element.code)"></button>
                                            <button type="button" class="btn btn-sm btn-outline-primary bi bi-people"
                                                    title="View users with this feature flag"
                                                    [attr.aria-label]="'View users of ' + element.code"
                                                    (click)="onViewUsers(element)"></button>
                                            <button type="button" class="btn btn-sm btn-outline-primary bi bi-person-plus"
                                                    title="Edit user feature flags"
                                                    [attr.aria-label]="'Add a user to ' + element.code"
                                                    (click)="onUserAdd(element.code)"></button>
                                            <button type="button" class="btn btn-sm btn-outline-primary bi bi-clock-history"
                                                    title="View the history of this feature flag"
                                                    [attr.aria-label]="'History of ' + element.code"
                                                    (click)="onHistory(element.code)"></button>
                                        </div>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>

                    <app-table-pager [total]="(this.total$ | async)!" [(page)]="this.service.page" [(pageSize)]="this.service.pageSize" />
                }

                @if (((this.total$ | async) ?? 0) == 0 && !(this.globalService.waitOverlayIsVisible$ | async)) {
                    <div class="card text-center bg-warning-subtle border border-warning rounded p-3 m-5">
                        <div class="card-body">
                            <i class="bi bi-exclamation-triangle-fill me-2"></i>No feature flags found.
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>

    <ng-template #editFeatureModal>
        <div class="modal-header">
            <h5 class="modal-title"><i class="bi bi-flag me-2"></i>Edit Feature Flag</h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="this.closeEditFeatureModal()"></button>
        </div>
        <form [formGroup]="editForm" (ngSubmit)="onSaveEdit()">
            <div class="modal-body">
                <div class="form-floating mb-3">
                    <input type="text" class="form-control-plaintext" formControlName="code" id="code" readonly>
                    <label class="form-label" for="code">Code</label>
                </div>
                <div class="form-floating mb-3">
                    <textarea id="description" class="form-control" style="height: 10em;" formControlName="description"></textarea>
                    <label for="description" class="form-label">Description</label>
                </div>
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="isEnabledSwitch" formControlName="isEnabled">
                    <label class="form-check-label" for="isEnabledSwitch">Is Enabled</label>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary" [disabled]="savingData || editForm.invalid">
                    @if (!savingData) {
                        <span>Save</span>
                    }
                    @else {
                        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    }
                </button>
                <button type="button" class="btn btn-secondary" (click)="this.closeEditFeatureModal()" [disabled]="savingData">Cancel</button>
            </div>
        </form>
    </ng-template>

    <ng-template #existingFeatureUsersModal>
        <div class="modal-header">
            <h5 class="modal-title"><i class="bi bi-people me-2"></i>Users with Feature Flag</h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="this.closeExistingFeatureUsersModal()"></button>
        </div>
        <div class="modal-body">

            <div class="callout callout-primary mt-0">
                <h5>{{ selectedFeature!.code }}</h5>
                {{ selectedFeature!.description }}
            </div>
            @if (!!selectedFeature!.users.length) {
                <div class="table-responsive">
                    <table class="table table-striped table-hover">
                        <thead>
                        <tr>
                            <th scope="col">Full Name</th>
                            <th scope="col">Email</th>
                            <th scope="col" class="text-center">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        @for (user of selectedFeature!.users; track user.email) {
                            <tr>
                                <td class="align-middle">{{ user.fullName }}</td>
                                <td class="align-middle font-monospace">{{ user.email }}</td>
                                <td class="align-middle text-center">
                                    <button class="btn btn-sm btn-primary bi bi-trash"
                                            [disabled]="savingData"
                                            title="Remove feature flag from user"
                                            (click)="onDeleteFeatureFlagUser(user.email)"></button>
                                </td>
                            </tr>
                        }
                        </tbody>
                    </table>
                </div>
            }
            @else {
                <div class="alert alert-info">
                    <i class="bi bi-info-circle me-2"></i>No users are associated with this feature.
                </div>
            }
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="this.closeExistingFeatureUsersModal()">Close</button>
        </div>
    </ng-template>

    <ng-template #historyDrawer>
        <app-history-drawer
            [title]="historyCode() ? 'History: ' + historyCode() : 'Recent changes to all flags'"
            [exportName]="historyCode() ? 'feature-flag-history-' + historyCode() : 'feature-flag-history'"
            [events]="historyFeed.events()"
            [loading]="historyFeed.loading()"
            [loadFailed]="historyFeed.loadFailed()"
            [hasMore]="historyFeed.hasMore()"
            (loadMore)="historyFeed.loadMore()"
            (retry)="historyFeed.retry()"
            (closed)="closeHistoryDrawer()">

            @if (historyHeader(); as flag) {
                <div class="callout callout-secondary mt-0">
                    <h5 class="font-monospace">{{ flag.code }}</h5>
                    <div class="mb-2">{{ flag.description }}</div>
                    @if (flag.isEnabled) {
                        <div>
                            <span class="badge text-bg-success me-1">ON</span>
                            @if (flag.enabledSince) {
                                Currently ON since {{ formatDateTime(flag.enabledSince) }} by {{ flag.enabledBy }}
                            } @else {
                                Currently ON. No enable event is in the change log.
                            }
                        </div>
                    } @else {
                        <div><span class="badge text-bg-secondary me-1">OFF</span> Currently OFF</div>
                    }
                    <div class="small text-body-secondary mt-2">
                        Created {{ formatDateTime(flag.createdAt) }}{{ flag.updatedAt ? ', last saved ' + formatDateTime(flag.updatedAt) : '' }}
                        <span class="fst-italic">(from the flag record, not the change log)</span>
                    </div>
                </div>
            }

            <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="includeUserChangesSwitch"
                       [checked]="includeUserChanges()"
                       (change)="onIncludeUserChanges($any($event.target).checked)">
                <label class="form-check-label" for="includeUserChangesSwitch">Show per-user changes</label>
            </div>
            <div class="small text-body-secondary mt-1">
                <i class="bi bi-info-circle me-1"></i>Logged events start on the day flag logging shipped.
            </div>
        </app-history-drawer>
    </ng-template>

    <ng-template #addFeatureForUserModal>
        <div class="modal-header">
            <h5 class="modal-title"><i class="bi bi-person-gear me-2"></i>Add User Feature Flag</h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="this.closeAddFeatureUsersModal()"></button>
        </div>
        <form [formGroup]="userAddForm" (ngSubmit)="onSaveUserAdd()">
            <div class="modal-body">
                <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="ue-code" formControlName="code" readonly>
                    <label for="ue-code">Code</label>
                </div>

                @if (loadingCustomers$ | async) {
                    <div class="mb-3"><span class="spinner-border spinner-border-sm me-1"></span> Loading customers...</div>
                }
                @else {
                    <div class="form-floating mb-3">
                        <select class="form-select" id="ue-customer" formControlName="customerId" (change)="onUserAddCustomerChange($event)">
                            @for (customer of customers; track customer.id; ) {
                                <option value="{{ customer.id }}">{{ customer.name }}</option>
                            }
                        </select>
                        <label for="ue-customer">Customer</label>
                    </div>
                }

                @if (userAddForm.get("customerId")?.value) {
                    @if (loadingUsers$ | async) {
                        <div class="mb-3"><span class="spinner-border spinner-border-sm me-1"></span> Loading users...</div>
                    }
                    @else {
                        <div class="form-floating mb-3">
                            <select class="form-select" id="ue-user" formControlName="email" [disabled]="(loadingUsers$ | async) || !users.length">
                                @for (user of users; track user.id) {
                                    <option [ngValue]="user.email">{{ user.fullName }} ({{ user.email }})</option>
                                }
                            </select>
                            <label for="ue-user">User</label>
                        </div>
                    }
                    <input class="form-input" type="hidden" id="ue-isEnabled" formControlName="isEnabled">
                }
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary" [disabled]="savingData || userAddForm.invalid">
                    @if (!savingData) {
                        <span>Save</span>
                    }
                    @else {
                        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    }
                </button>
                <button type="button" class="btn btn-secondary" (click)="this.closeAddFeatureUsersModal()" [disabled]="savingData">Cancel</button>
            </div>
        </form>
    </ng-template>
</div>
